// ---------------------------------------------------------------------------
// Viz DSL Crystallizer — thin client over POST /api/crystallize_dsl.
// The actual DSL traversal, schema building, prompt construction, per-pin LLM
// calls and provenance verification all live server-side in
// server/viz_dsl_crystallizer.js (one source of truth, also reachable from
// the rebuild_summary pipeline without HTTP). Keep this file small — if you
// reach for new logic here, add it server-side and re-fetch instead.
// ---------------------------------------------------------------------------

export async function crystallizeWithLLM(dsl, sourcePins, opts = {}) {
  const { model, pinSourceMap, onProgress } = opts;

  // The server runs every per-pin LLM call in one HTTP turn — we don't have
  // per-pin progress to surface here, just a single waiting state.
  onProgress?.("Crystallizing…");

  const response = await fetch("/api/crystallize_dsl", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      dsl,
      sourcePins,
      ...(model ? { model } : {}),
      ...(pinSourceMap ? { pinSourceMap } : {})
    })
  });

  if (!response.ok) {
    const text = await response.text().catch(() => "");
    throw new Error(`crystallize_dsl HTTP ${response.status}: ${text || response.statusText}`);
  }

  const json = await response.json();
  if (!json.success) {
    throw new Error(`Crystallization failed: ${json.error || "unknown error"}`);
  }

  onProgress?.("Done.");
  return {
    data: json.data,
    raw: JSON.stringify(json.data, null, 2),
    calls: json.calls || [],
    provenance: json.provenance || {}
  };
}

export default { crystallizeWithLLM };
